import {Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {MasterDataService} from '../../views/oes/services/master-data.service';
import {Subscription} from 'rxjs/Subscription';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-export-master-data-modal',
    templateUrl: './export-master-data-modal.component.html',
    styleUrls: ['./export-master-data-modal.component.scss'],
    preserveWhitespaces: true,
    providers: [
        MasterDataService
    ]
})
export class ExportMasterDataModalComponent implements OnInit, OnDestroy {

    @ViewChild('exportModal') exportModal: ElementRef;
    @ViewChild('header') header: ElementRef;
    @ViewChild('content') content: ElementRef;
    @ViewChild('footer') footer: ElementRef;

    public customers: Array<any>;
    private subscription: Subscription;
    public cols: Array<any>;
    public form: FormGroup;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<ExportMasterDataModalComponent>,
        private masterDataService: MasterDataService,
        private formBuilder: FormBuilder,
        private toastr: ToastrService
    ) {

    }

    ngOnInit() {
        this.customers = [];
        this.cols = this.data['cols'].filter(col => col['export']['visible']);
        this.form = this.formBuilder.group({
            checkboxes: this.buildColumns(),
            customer: null
        });
        this.form.controls['customer'].setValue(null);

        this.subscription = this.masterDataService.importPreload().subscribe(result => {
            if (result.success) {
                this.customers = result.data.customers.map(customer => {
                    return {
                        id: customer.CU1_ID + '_' + customer.CO1_ID,
                        name: customer.CU1_NAME
                    };
                });
                if (this.customers.length === 1) {
                    this.form.controls['customer'].setValue(this.customers[0].id);
                }
            } else {
                this.closeDialog(null);
            }
        }, () => {
            this.closeDialog(null);
        });
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    closeDialog(value) {
        this.dialogRef.close(value);
    }

    get checkboxes() {
        return this.form.get('checkboxes');
    };

    buildColumns() {
        const arr = this.cols.map(col => {
            return this.formBuilder.control(col['export']['checked']);
        });

        return this.formBuilder.array(arr);
    }

    submit(form) {
        const formValue = Object.assign({}, {
            columns: form.checkboxes.map((selected, i) => {
                return {
                    id: this.cols[i].field, selected: selected
                }
            }).filter(v => v.selected === true)
        });
        const cols = [];
        formValue.columns.forEach(col => {
            cols.push(col['id']);
        });

        if (form.customer == null || cols.length === 0) {
            this.toastr.error('Customer and at least one column need to be selected.', 'Error');
        } else {
            const customerSplit = form.customer.split('_');
            this.closeDialog({
                CU1_ID: customerSplit[0],
                CO1_ID: customerSplit[1],
                columns: cols
            });
        }
    }

}


// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/components/export-master-data-modal/export-master-data-modal.component.ts